import { NumberField } from '@calabriocloud/beacon-ui'
import { useTranslation } from 'react-i18next'
import { FieldProps } from './constants'

export const ScoreField = ({ classifier, field, onChange  }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, fieldKey: null }

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <NumberField
        label={t(classifier.name)}
        className='w-40'
        data-testid='classifier-score-input'
        minValue={0}
        maxValue={100}
        value={parseInt(field?.field || '0')}
        onChange={value => {
          onChange({
            ...baseValue,
            field: value.toString(),
            name: `${t(classifier.name)} ${value.toString().padStart(2, '0')}`,
          })
        }}
      />
    </div>
  )
}
